/**
 * Public digest-unsubscribe API (external recipients of the weekly org
 * digest or the admins digest; the token names which).
 *
 * No auth: the recipient has no account, and the signed token in the URL is
 * the entire grant. GET is read-only (mail scanners prefetch links); only
 * the explicit POST unsubscribes.
 */

import { api } from './client';

export type DigestList = 'weekly' | 'admin';

export interface DigestUnsubscribeInfo {
  orgName: string;
  email: string;
  /** Which list the token belongs to. */
  list: DigestList;
  /** "weekly digest" or "admins digest", for the page copy. */
  listLabel: string;
  /** False when the address is no longer on the list (already unsubscribed). */
  subscribed: boolean;
}

export async function getDigestUnsubscribeInfo(token: string): Promise<DigestUnsubscribeInfo> {
  const res = await api.get<DigestUnsubscribeInfo>(
    `/digest/unsubscribe/${encodeURIComponent(token)}`
  );
  return res.data;
}

export async function postDigestUnsubscribe(token: string): Promise<void> {
  await api.post(`/digest/unsubscribe/${encodeURIComponent(token)}`);
}
